import { cn } from "@/lib/utils";

/**
 * Deterministic gradient for videos without a poster (embed whose provider gave
 * none, or an upload ffmpeg could not frame). Hue is derived from the slug so
 * the grid stays varied without storing anything.
 */
export function VideoPosterFallback({ slug, className }: { slug: string; className?: string }) {
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 31 + slug.charCodeAt(i)) % 360;
  const a = `oklch(62% 0.09 ${h})`;
  const b = `oklch(38% 0.08 ${(h + 40) % 360})`;
  return (
    <div
      aria-hidden
      className={cn("bg-[image:var(--vp)]", className)}
      style={{ ["--vp" as string]: `linear-gradient(135deg, ${a}, ${b})` }}
    />
  );
}
